module.exports = __webpack_public_path__ + "img/copy.2573324b.svg";